import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Heading, PageTitle } from '../../../components';
import { kolejWaskotorowaData } from '../../../constants';
import '../KolejWaskotorowa.css';

import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';

const KolejWaskotorowaGaleria = () => {
    const { gallery } = kolejWaskotorowaData;
    const [index, setIndex] = useState(-1);

    const currentImage = gallery.images[index];
    const nextIndex = (index + 1) % gallery.images.length;
    const nextImage = gallery.images[nextIndex] || currentImage;
    const prevIndex = (index + gallery.images.length - 1) % gallery.images.length;
    const prevImage = gallery.images[prevIndex] || currentImage;

    const openLightbox = (nextIndexToOpen) => setIndex(nextIndexToOpen);
    const closeLightbox = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);

    return (
        <>
            <PageTitle
                title='Kolej Wąskotorowa'
                page='Galeria'
                heading={gallery.title}
                subTitle={gallery.subtitle}
            />

            <section className='gallery kw-gallery-partners-style'>
                <Heading title='Galeria' subTitle='Zobacz galerie zdjęć z Koleją Wąskotorową' />

                <div className='box-container'>
                    {gallery.images.map((item, imageIndex) => (
                        <div key={imageIndex} className={`gallery-item gallery-${imageIndex + 1}`}>
                            <img src={item} alt='' />
                            <div className='content'>
                                <button onClick={() => openLightbox(imageIndex)}>
                                    <FaPlus className='icon' />
                                </button>
                            </div>
                        </div>
                    ))}

                    {index !== -1 && (
                        <Lightbox
                            mainSrc={currentImage}
                            mainSrcThumbnail={currentImage}
                            nextSrc={nextImage}
                            nextSrcThumbnail={nextImage}
                            prevSrc={prevImage}
                            prevSrcThumbnail={prevImage}
                            onCloseRequest={closeLightbox}
                            onMovePrevRequest={handleMovePrev}
                            onMoveNextRequest={handleMoveNext}
                        />
                    )}
                </div>
            </section>
            <footer class="site-footer">
                <p>Zdjęcia 1 - 7 wykonał Michał Zajfert, rok 1993</p>
            </footer>
        </>
    );
};

export default KolejWaskotorowaGaleria;
